const MONTHS_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

/**
 * Modal de edição em massa de registros de pagamento.
 * Apenas campos que fazem sentido em bulk: nome do vídeo, mês, ano.
 */
export const BulkEditModal = ({
  open,
  onClose,
  selectedCount,
  form,
  setForm,
  onSubmit,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto" data-testid="bulk-edit-modal">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-2xl font-bold text-white mb-2">Edição em Massa</h2>
        <p className="text-slate-400 text-sm mb-6">
          {selectedCount} registro(s) selecionado(s). Apenas nome e data podem ser alterados.
        </p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nome do Vídeo/Projeto</label>
            <input
              type="text"
              value={form.video_name}
              onChange={e => setForm({ ...form, video_name: e.target.value })}
              placeholder="Deixe vazio para não alterar"
              className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500"
              data-testid="bulk-edit-video-name"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Mês</label>
              <select
                value={form.month}
                onChange={e => setForm({ ...form, month: e.target.value })}
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500"
                data-testid="bulk-edit-month"
              >
                <option value="">Não alterar</option>
                {MONTHS_PT.map((month, idx) => <option key={`m-${idx}`} value={idx + 1}>{month}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Ano</label>
              <select
                value={form.year}
                onChange={e => setForm({ ...form, year: e.target.value })}
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500"
                data-testid="bulk-edit-year"
              >
                <option value="">Não alterar</option>
                {[2023, 2024, 2025, 2026].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg transition-colors"
              data-testid="submit-bulk-edit-btn"
            >
              Salvar Alterações
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

/**
 * Modal para editar o texto adicional do banner de pagamento (5 dias).
 */
export const BannerSettingsModal = ({ open, onClose, draft, setDraft, onSave }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto" data-testid="banner-settings-modal">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-2xl font-bold text-white mb-2">Texto Adicional</h2>
        <p className="text-slate-400 text-sm mb-4">
          Configure um aviso que aparecerá abaixo da mensagem de pagamento em 5 dias.
          Deixe vazio para remover.
        </p>
        <textarea
          value={draft}
          onChange={e => setDraft(e.target.value)}
          rows={4}
          placeholder="Ex: Pagamentos de dezembro serão processados apenas em janeiro..."
          className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white text-sm focus:outline-none focus:border-teal-500 resize-none"
          data-testid="banner-text-input"
        />
        <div className="flex gap-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onSave}
            className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg transition-colors"
            data-testid="save-banner-btn"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};
